module.exports = __webpack_public_path__ + "static/media/bg_safe.4618ead1.svg";